import React from 'react';
import PropTypes from 'prop-types';
import Avatar from '@strava/ui/Avatar';
import styles from './FriendListItem.scss';

const FriendListItem = ({ friend, children }) => (
  <li className={styles.listRow}>
    <div className={styles.athleteMetadata}>
      <Avatar
        src={friend.picture || ''}
        name={friend.displayName}
        alt=""
        type="athlete"
        badge={friend.badge}
      />
      <div className={styles.nameAndLocation}>
        <h4>{friend.displayName}</h4>
        <p className={styles.location}>{friend.displayLocation}</p>
      </div>
    </div>
    {children}
  </li>
);

FriendListItem.propTypes = {
  friend: PropTypes.shape({
    picture: PropTypes.string,
    badge: PropTypes.string,
    displayName: PropTypes.string,
    displayLocation: PropTypes.string
  }).isRequired,
  children: PropTypes.node.isRequired
};

export default FriendListItem;
